/* eslint-disable react/jsx-no-undef */
import * as React from 'react';



import EnvelopamentoWeb from '../../../../../assets/images/landingPage/produtos/ativo208-1140x1021.png';
import BackBusWeb from '../../../../../assets/images/landingPage/produtos/ativo2011-1140x1373.webp';
import EnvelopamentoLight from '../../../../../assets/images/landingPage/produtos/ativo205-1140x855.png';
import Backseat from '../../../../../assets/images/landingPage/produtos/ativo2010-1140x1475.png';

import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, ImageContent, SidebySideContent, ImageViewport } from './styles';
import { useRef, useState } from 'react';

interface INavBar {

}



const NossosProdutos: React.FC<INavBar> = () => {
    const carouselRef = useRef<HTMLDivElement | null>(null);
    const stripRef = useRef<HTMLDivElement | null>(null);
    const rafRef = useRef<number | null>(null);
    const [translateX, setTranslateX] = useState(0);

    // Scroll horizontal controlado pelo scroll vertical
     React.useEffect(() => {
    function calcAndUpdate() {
      if (!carouselRef.current || !stripRef.current) return;

      const viewportRect = carouselRef.current.getBoundingClientRect();
      const stripRect = stripRef.current.getBoundingClientRect();

      // largura visível do "viewport" do carrossel (normalmente largura do container)
      const viewportWidth = carouselRef.current.clientWidth;
      // largura total da faixa de imagens
      const stripWidth = stripRef.current.scrollWidth;

      // quando o topo do viewport do elemento estiver entrando/saindo da janela:
      const start = window.innerHeight; // ponto inicial (fora da tela)
      const end = -stripRect.height; // ponto final (quando saiu para cima)
      // progress normalizado (0..1) baseado na posição do topo do elemento
      const progress = Math.min(Math.max((stripRect.top - end) / (start - end), 0), 1);

      // quanto precisamos mover no máximo: largura total - largura visível
      const maxTranslate = Math.max(stripWidth - viewportWidth, 0);

      // mapeia 0..1 -> 0 .. -maxTranslate
      const tx = -progress * maxTranslate;

      setTranslateX(tx);
    }

    // handler com rAF para performance
    const onScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(calcAndUpdate);
    };

    // calc inicial (caso a seção já esteja visível)
    calcAndUpdate();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [translateX]);

    const dadosWeb = [
        {image:EnvelopamentoLight, text: 'ENVELOPAMENTO Light'},
        {image:BackBusWeb, text: 'BACKBUS WEB'},
        {image:Backseat, text: 'BACKSEAT'},
        {image:EnvelopamentoWeb, text: 'ENVELOPAMENTO WEB'},
    ]

    return (
        <BaseComp id='produtolp'>
            <BaseContent>
                <SidebySideContent>
                    <TextContent>
                        <TextBody>
                            <TextTitle>
                                <h1>NOSSOS PRODUTOS</h1>
                            </TextTitle>
                        </TextBody>
                    </TextContent>
                    <ImageViewport ref={carouselRef} className='marquee'>
                        {/* Strip: contém as imagens em linha e será transladado */}
                        <ImageContent
                            ref={stripRef}
                        >
                            {dadosWeb.map((data) => (
                            <img key={data.text} src={data.image} className="imagens" alt={data.text} />                            
                            ))}
                            {dadosWeb.map((data) => (
                            <img key={data.text} src={data.image} className="imagens" alt={data.text} />                            
                            ))}
                        </ImageContent>
                    </ImageViewport>
                </SidebySideContent>
            </BaseContent>
        </BaseComp>
    );
}

export { NossosProdutos }